@if (visible()) {
<div
  class="fixed top-4 right-4 z-50 w-80 rounded-xl border border-border bg-card text-card-foreground shadow-lg shadow-black/10 outline-1 outline-black/[0.06] dark:shadow-black/40 dark:outline-white/10 animate-slide-up-fade-in overflow-hidden"
  role="status"
  aria-live="polite">

  <div class="p-4">
    <div class="flex items-start gap-3">

      @if (phase() === 'downloading') {
      <!-- Download icon -->
      <div class="shrink-0 rounded-full bg-primary p-2 text-primary-foreground">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="size-5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" x2="12" y1="3" y2="15" />
        </svg>
      </div>
      } @else {
      <!-- Success icon -->
      <div class="shrink-0 rounded-full bg-emerald-600 p-2 text-white dark:bg-emerald-500">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="size-5">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </div>
      }

      <div class="min-w-0 flex-1">
        @if (phase() === 'downloading') {
        <p class="text-sm font-semibold text-primary">Downloading&hellip;</p>
        <p class="mt-0.5 text-xs text-muted-foreground truncate">{{ uploadService.secureDownloadName() }}</p>
        } @else {
        <p class="text-sm font-semibold text-primary">Download complete!</p>
        <p class="mt-0.5 text-xs text-muted-foreground">Saved to your Downloads folder.</p>
        }
      </div>

      <button
        type="button"
        (click)="dismiss()"
        class="shrink-0 rounded-md text-muted-foreground hover:text-card-foreground focus:outline-2 focus:outline-offset-2 focus:outline-ring"
        aria-label="Dismiss">
        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </button>
    </div>

    @if (phase() === 'downloading') {
    <div class="mt-3">
      <div class="flex justify-between mb-1">
        <span class="text-xs text-muted-foreground">{{ progress() }}%</span>
      </div>
      <div class="w-full rounded-full bg-muted h-1.5">
        <div
          class="h-1.5 rounded-full bg-primary transition-all duration-300"
          [style.width.%]="progress()">
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
